export { findFirstMatchIndex } from './find-first-match-index/find-first-match-index'
export { normalizerGeneratorArray } from './normalizer-generator-array/normalizer-generator-array'
export { removeDuplicateDeliveries } from './remove-duplicated-deliveries/remove-duplicated-deliveries'
export { removeItemsFromArrayByAmount } from './remove-items-from-array-by-amount/remove-items-from-array-by-amount'
export type { GroupDeliveriesForDashboard } from './sort-deliveries-by-status'
export {
  deliveryStatusClassification,
  groupDeliveriesByStatus,
  groupDeliveryByStatus,
} from './sort-deliveries-by-status'
